import { VOTES_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformAggVoteToLegacyVote = (vote, isEnabled: boolean) => ({
	votes: vote.count != null ? Number(vote.count) : 0,
	hasVoted: vote.hasVoted ?? false,
	isEnabled,
});

export const transformAggVotesToLegacyField: FieldTransformer<typeof VOTES_TYPE> = (node) => {
	if (node.type !== VOTES_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.vote
			? transformAggVoteToLegacyVote(node.vote, !!node.selectedUsersConnection?.edges)
			: null,
		schema: {
			configuration: null,
			custom: null,
			items: null,
			renderer: null,
			system: VOTES_TYPE,
			type: VOTES_TYPE,
		},
	};
};
